module.exports = __webpack_public_path__ + "img/free_multiplier_6.dc068709.png";